import {
  ADD_CAMPAIGN_ADVERTISING_ACCOUNTS,
  DELETE_CAMPAIGN_ADVERTISING_ACCOUNTS,
  GET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
  GET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST,
  HIDE_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER,
  SET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
  SET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST,
  SHOW_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER,
  UPDATE_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
  GET_CAMPAIGN_CUSTOMER_DATA,
  SET_CAMPAIGN_CUSTOMER_DATA,
  WAREHOUSE_PLATFORM_TRIGGER
} from "./actionTypes";

export const getCampaignAdvertisingAccountsList = data => ({
  type: GET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST,
  payload: data
})

export const setCampaignAdvertisingAccountsList = payload => ({
  type: SET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST,
  payload
})

export const showCampaignAdvertisingAccountsListLoader = () => ({
  type: SHOW_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER
})

export const hideCampaignAdvertisingAccountsListLoader = () => ({
  type: HIDE_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER
})

export const addCampaignAdvertisingAccount = (cabinet = {}, data = {}) => ({
  type: ADD_CAMPAIGN_ADVERTISING_ACCOUNTS,
  payload: { cabinet, data }
});

export const deleteCampaignAdvertisingAccount = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_ADVERTISING_ACCOUNTS,
  payload: { id, data }
});

export const getCampaignAdvertisingAccountProfile = id => ({
  type: GET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
  payload: id
})

export const setCampaignAdvertisingAccountProfile = payload => ({
  type: SET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
  payload
})

export const updateCampaignAdvertisingAccountProfile = (id, cabinet = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
  payload: {id, cabinet, data }
})

export const getCampaignCustomerData = () => ({
  type: GET_CAMPAIGN_CUSTOMER_DATA,
})

export const setCampaignCustomerData = (data) => ({
  type: SET_CAMPAIGN_CUSTOMER_DATA,
  payload: data
})

export const postWHTrigger = (platforms) => ({
  type: WAREHOUSE_PLATFORM_TRIGGER,
  payload: platforms
})